const popularHeliports = [
	{
		"distance_in_miles": 3.41,
		"id": 9694,
		"name": "London Heliport (Battersea)",
		"address": "London, England",
		"airport_code": "EGLW",
		"lat": 51.469454,
		"lng": -0.17856249999999996,
		"active": true,
		"type": "helipad",
		"is_airport": 0
	},
	{
		"distance_in_miles": 1.28,
		"id": 5784,
		"name": "Farnborough Airport",
		"address": "Farnborough, England",
		"airport_code": "FAB",
		"lat": 51.2757988,
		"lng": -0.77633297,
		"active": true,
		"type": "airport",
		"is_airport": 1
	},
	{
		"distance_in_miles": 1,
		"id": 9674,
		"name": "Silverstone Motor Racecourse",
		"address": "Silverstone, England",
		"airport_code": null,
		"lat": 52.0770268,
		"lng": -1.0260850000000001,
		"active": true,
		"type": "helipad",
		"is_airport": 0
	},
	{
		"distance_in_miles": 0,
		"id": 8642,
		"name": "Goodwood Motor Racecourse & Airfield",
		"address": "Chichester, England",
		"airport_code": null,
		"lat": 50.859426,
		"lng": -0.751715,
		"active": true,
		"type": "airfield",
		"is_airport": 0
	},
	{
		"distance_in_miles": 0,
		"id": 9610,
		"name": "Brocket Hall",
		"address": "Hatfield, England",
		"airport_code": null,
		"lat": 51.8026221,
		"lng": -0.2403672,
		"active": true,
		"type": "helipad",
		"is_airport": 0
	},
]

export default popularHeliports
